document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('form[data-product-form]');
  var CUR = (form && form.dataset.currency) ? form.dataset.currency : '$';
  var offerPos = form && form.dataset.offerPos ? form.dataset.offerPos : '';
  var sizePos = form && form.dataset.sizePos ? form.dataset.sizePos : '';
  var colorPos = form && form.dataset.colorPos ? form.dataset.colorPos : '';

  /* ---- Variant matrix (matched by option position, so it works for any
          product whether it has 1 option (Smooche) or 3 (Ondea)) ---- */
  var mapEl = document.querySelector('[data-variant-map]');
  var variants = mapEl ? JSON.parse(mapEl.textContent) : [];
  var idInput = form ? form.querySelector('input[name="id"]') : null;
  var priceNow = document.querySelector('[data-price-now]');
  var priceWas = document.querySelector('[data-price-was]');
  var priceSave = document.querySelector('[data-price-save]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var atcBtn = document.querySelector('[data-main-atc]');
  var colorName = document.querySelector('[data-color-name]');
  var mainImg = document.querySelector('[data-main-image]');

  var sizePills = document.querySelectorAll('.size-pill');
  var offers = document.querySelectorAll('.offer');
  var swatches = document.querySelectorAll('.color-swatch');

  function sel(nodes) {
    for (var i = 0; i < nodes.length; i++) if (nodes[i].classList.contains('selected')) return nodes[i];
    return null;
  }
  var state = {
    size: sel(sizePills) ? sel(sizePills).dataset.size : null,
    offer: sel(offers) ? sel(offers).dataset.offer : null,
    color: sel(swatches) ? sel(swatches).dataset.color : null
  };

  function money(cents) { return CUR + (cents / 100).toFixed(2); }

  function matchVariant() {
    return variants.find(function (x) {
      var ok = true;
      if (sizePos) ok = ok && x['o' + sizePos] === state.size;
      if (offerPos) ok = ok && x['o' + offerPos] === state.offer;
      if (colorPos) ok = ok && x['o' + colorPos] === state.color;
      return ok;
    });
  }

  /* ---- Multipack: let the buyer pick each bra (size + colour) ---- */
  var bundle = document.querySelector('[data-bundle]');
  var bra1Input = document.querySelector('[data-bra1]');
  var braRows = document.querySelectorAll('[data-bra-row]');

  function qtyFromOffer() { var n = parseInt(state.offer, 10); return isNaN(n) ? 1 : n; }

  function rowValue(row) {
    var s = row.querySelector('.bra-size');
    var c = row.querySelector('.bra-color');
    return (s ? s.value : '') + ' / ' + (c ? c.value : '');
  }

  function updateBundle() {
    if (!bundle) return;
    var qty = qtyFromOffer();
    bundle.hidden = qty < 2;
    if (bra1Input) {
      bra1Input.disabled = qty < 2;
      bra1Input.value = (state.size || '') + ' / ' + (state.color || '');
    }
    braRows.forEach(function (row) {
      var n = parseInt(row.dataset.braRow, 10);
      var prop = row.querySelector('[data-bra-prop]');
      var show = qty >= n;
      row.hidden = !show;
      if (prop) {
        prop.disabled = !show;
        if (show) prop.value = rowValue(row);
      }
    });
  }

  braRows.forEach(function (row) {
    row.querySelectorAll('select').forEach(function (s) {
      s.addEventListener('change', function () {
        var prop = row.querySelector('[data-bra-prop]');
        if (prop && !prop.disabled) prop.value = rowValue(row);
      });
    });
  });

  function sync(updateImage) {
    if (!variants.length) { updateBundle(); return; }
    var v = matchVariant();
    if (!v) { updateBundle(); return; }
    if (idInput) idInput.value = v.id;
    if (priceNow) priceNow.textContent = money(v.p);
    if (stickyPrice) stickyPrice.textContent = money(v.p);
    if (priceWas) {
      priceWas.textContent = v.c > v.p ? money(v.c) : '';
      priceWas.style.display = v.c > v.p ? '' : 'none';
    }
    if (priceSave) {
      if (v.c > v.p) {
        priceSave.textContent = '-' + Math.round((1 - v.p / v.c) * 100) + ' %';
        priceSave.style.display = '';
      } else {
        priceSave.style.display = 'none';
      }
    }
    if (colorName && state.color) colorName.textContent = state.color;
    if (updateImage && mainImg && v.img) {
      mainImg.src = v.img;
      document.querySelectorAll('.product__thumbs img').forEach(function (x) { x.classList.remove('active'); });
    }
    if (atcBtn) {
      atcBtn.disabled = !v.a;
      atcBtn.textContent = v.a ? 'Add to cart — Ships within 24-48h' : 'Sold out in this combination';
    }
    updateBundle();
  }

  sizePills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      sizePills.forEach(function (p) { p.classList.remove('selected'); });
      pill.classList.add('selected');
      state.size = pill.dataset.size;
      sync(false);
    });
  });

  offers.forEach(function (offer) {
    offer.addEventListener('click', function () {
      offers.forEach(function (o) { o.classList.remove('selected'); });
      offer.classList.add('selected');
      var input = offer.querySelector('input');
      if (input) input.checked = true;
      state.offer = offer.dataset.offer;
      sync(false);
    });
  });

  swatches.forEach(function (sw) {
    sw.addEventListener('click', function () {
      swatches.forEach(function (s) { s.classList.remove('selected'); });
      sw.classList.add('selected');
      state.color = sw.dataset.color;
      sync(true);
    });
  });

  sync(false);

  /* ---- Sticky ATC (mobile) ---- */
  var sticky = document.querySelector('.sticky-atc');
  if (sticky && atcBtn) {
    var obs = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    obs.observe(atcBtn);
    var stickyBtn = sticky.querySelector('button');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (form) form.submit();
      });
    }
  }

  /* ---- Product gallery thumbs ---- */
  document.querySelectorAll('.product__thumbs img').forEach(function (t) {
    t.addEventListener('click', function () {
      if (mainImg) mainImg.src = t.dataset.full;
      document.querySelectorAll('.product__thumbs img').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
    });
  });

  /* ---- Mobile nav: close on link click ---- */
  document.querySelectorAll('.mobile-nav__panel a').forEach(function (a) {
    a.addEventListener('click', function () {
      var d = a.closest('details');
      if (d) d.removeAttribute('open');
    });
  });

  /* ---- Cart quantity auto-update ---- */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      input.closest('form').submit();
    });
  });
});
